import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PopupNames } from 'contexts/PopupContext';

import { setHasMatch } from 'store/common/commonSlice';
import { getHasMatch } from 'store/common/selectors';

import { usePopup } from './usePopup';

export const useMatchPopup = () => {
  const dispatch = useDispatch();

  const newMatch = useSelector(getHasMatch);

  const { handleAction, handleClose, handleOpenASAP } = usePopup(
    PopupNames.PerfectMatch
  );

  handleAction.current = (action: { type: string }) => {
    if (action.type === 'close') {
      handleClose();
    }
  };

  useEffect(() => {
    if (newMatch) {
      dispatch(setHasMatch(null));
      handleOpenASAP({ contact: newMatch });
    }
  }, [dispatch, handleOpenASAP, newMatch]);
};
